export default {
  menu: {
    home: '홈',
    alliance: '내 연맹',
    mall: '포켓몰',
    me: '회사 소개'
  },
  layout: {
    loading: '로딩 중',
    trading: '거래 진행 중입니다. 잠시만 기다려 주세요...',
    comingsoon: '곧 출시됩니다',
    success: '성공',
    error: '실패'
  },
  header: {
    home: '홈',
    alliance: '내 연맹',
    mall: '포켓몰',
    about: '회사 소개',
    lang: {
      zh: '简体中文',
      zhTW: '繁體中文',
      en: 'English',
      ko: '한국어',
      ja: '日本語'
    }
  },
  period: {
    m5: '5분',
    m15: '15분',
    h1: '1시간',
    h4: '4시간',
    d1: '일',
    w1: '주',
    m1: '월'
  },
  home: {
    slogan1: '자산 가치를 높이세요',
    slogan2_part1: '',
    slogan2_pocket: '포켓',
    slogan2_part2: '에서 시작하세요',
    slogan3: '안전 · 안정 · 고수익',
    explore: '더 알아보기',
    alliance_pack: '포켓 연맹 패키지',
    alliance_desc: '최대 5,000위안 상당의 희귀 카드 획득 기회! 포켓 토큰 지급 및 누적 최대 360위안 혜택 제공!',
    join_alliance: '포켓 연맹 가입',
    mall: '포켓몰',
    mall_desc: '단순한 쇼핑이 아닌 새로운 저축 방식',
    ecosystem: '전략적 파트너 - DRS',
    ecosystem_desc: '협동조합의 성장을 지원하고 공무원의 부담을 줄입니다.',
    referrer_title: '추천인 주소',
    referrer_placeholder: '추천인 주소를 입력하세요',
    confirm: '확인'
  },
  alliance: {
    mint_pool: '채굴 풀',
    token_count: 'TOKEN 수량',
    usdt_total: 'USDT 총량',
    open_price: '시가',
    current_value: '현재 가치',
    static_income: '정적 수익',
    my_token: '내 TOKEN 수량',
    withdraw: '출금',
    fill_address: '주소 입력',
    view_receipt: '배송 정보 보기',
    dynamic_income: '동적 수익',
    current_node: '현재 노드',
    large_node: '대형 노드',
    repurchase_count: '재구매 횟수',
    current_pack: '현재 패키지',
    max_return: '최대 수익',
    withdrawn_income: '출금 완료 수익',
    current_income: '현재 수익',
    my_pack: '내 패키지',
    referrer_address: '추천인 주소',
    community_subsidy: '커뮤니티 보조금',
    buy_node: '노드 구매',
    my_team: '내 팀',
    team_pack: '팀 패키지',
    team_small_node: '팀 소형 노드',
    team_large_node: '팀 대형 노드',
    my_referrals: '내 추천인',
    node: '노드',
    date: '날짜',
    small_node: '소형 노드',
    recommend: '추천',
    high_return: '고수익',
    buy: '구매',
    small_node_desc: '개인 사용자에게 적합하며 가성비가 높고 생태계 구축에 쉽게 참여할 수 있습니다.',
    large_node_desc: '고급 사용자에게 적합하며 더 높은 수익과 생태계 참여 기회를 제공합니다.',
    fill_receipt_info: '배송 정보 입력',
    select_region: '지역 선택',
    select_address: '주소',
    receiver: '수령인',
    phone: '연락처',
    submit: '제출',
    cancel: '취소',
    purchase_node: '노드 구매',
    select_node: '구매할 노드를 선택하세요',
    your_address: '배송 주소',
    your_phone: '연락처',
    shipping_status: '배송 상태',
    shipp: '배송 대기',
    shipped: '배송 완료',
    shipping_method: '배송 방법',
    tracking_number: '운송장 번호',
    close: '닫기',
    postcode: '우편번호',
    endvalue: '최종 수익',
    copylink: '초대 링크 복사',
    fundinfo: '상세 내역',
    myorder: '내 주문',
    orderno: '주문 번호',
    getthings: '수령하기',
    geted: '수령 완료',
    gettime: '수령 시간',
    packamount: '패키지 금액',
    nonode: '없음',
    teamsub: '커뮤니티 보조금',
    pocketname: '포켓 연맹',
    pocketname1: '참여와 성원에 감사드립니다!',
    pocketname2: '지정된 오프라인 매장에서 상품을 수령해 주세요. 행운이 가득하시고 희귀 카드를 획득하시길 바랍니다!',
    nodealert:'수요추장',
    nodealert2:'사람',
  },
  me: {
    about_alliance: '포켓 얼라이언스 소개',
    alliance_rule1: '포켓 얼라이언스는 Web3를 핵심으로 하는 혁신적인 생태계 연합으로, 소비 가치 증대, 저축 가치 증대, 수집 가치 증대, 금융 가치 증대를 하나로 통합한 가치 생태계 구축에 전념하고 있습니다.',
    alliance_rule2: '우리는 쉽고 이해하기 쉬우며 진입 장벽이 낮은 방식으로 더 많은 사람들이 Web3 시대의 발전 기회를 접하고 참여하여, 자산 가치를 장기적으로 축적하고 성장시킬 수 있도록 돕고자 합니다.',
    alliance_rule3: '포켓 얼라이언스는 보드게임 소셜 활동을 시작점으로 하여 즐겁고 흥미로운 상호작용을 통해 사람들 간의 신뢰와 연결을 구축합니다. 또한 커뮤니티 공동 구축을 기반으로 공유, 학습, 협력을 통해 활기찬 가치 네트워크를 만들어갑니다.',
    alliance_rule4: '포켓 얼라이언스 생태계에서는 소비가 더 이상 단순한 지출이 아니며, 저축은 단순한 보관이 아니고, 수집은 단순한 취미가 아닌 지속적으로 가치를 창출하는 생태 순환이 됩니다.',
    alliance_rule5: '우리의 비전',
    alliance_rule6: '모든 사람이 자신만의 가치 포켓을 가지고, Web3 시대에 자산을 지키고, 축적하며, 다음 세대에 전할 수 있도록 합니다.',
    alliance_rule7: '우리의 미션',
    alliance_rule8: '소셜 네트워크로 가치를 연결하고, 생태계를 통해 부가가치를 창출하며, Web3를 모든 가정에 보급합니다.',
    alliance_rule9: '우리의 핵심 가치',
    alliance_rule10: '💰 소비 가치 증대 — 모든 소비를 더욱 가치 있게',
    alliance_rule11: '🏦 저축 가치 증대 — 자금이 성장할 수 있는 기회를 제공',
    alliance_rule12: '🃏 수집 가치 증대 — 취미를 자산으로',
    alliance_rule13: '📈 금융 가치 증대 — 가치가 지속적으로 순환하도록',
    alliance_rule14: '🤝 커뮤니티 공동 구축 — 공유를 통해 더 큰 가치를 창출',
    alliance_rule15: '🌐 Web3 역량 강화 — 누구나 미래 경제에 참여할 수 있도록',
    alliance_rule16: '포켓 얼라이언스 — 소비를 자산으로, 소셜을 가치로, 미래를 포켓 속으로.',
    alliance_rule17: '포켓 얼라이언스 — 모든 회원의 포켓에 부를 담다.',
    about_node: '노드 소개',
    node_rule1: '1. 300U 투자 시 소형 노드 자격 획득',
    node_rule2: '2. 800U 투자 시 대형 노드 자격 획득',
    pocketname: '포켓 토큰',
    pocketprice: '현재 시가총액',
    pockettrade: '거래량',
},
  mall: {
    coming_soon: '곧 출시됩니다...'
  },
  chart: {
    open: '시가',
    close: '종가',
    high: '고가',
    low: '저가',
    change: '변동 금액',
    change_rate: '변동률',
    volume: '거래량'
  }
};